import React from 'react';
import { Navbar, Footer } from '../components/Layout';

const WORKSHOP_IMAGE = "https://res.cloudinary.com/dmxxscqpl/image/upload/v1777370232/workshop_image_qrkqce.png";
const HERO_IMAGE = "https://res.cloudinary.com/dmxxscqpl/image/upload/v1777370240/hero_image_yabha6.png";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="about-page">
      <Navbar />
      
      {/* Hero */}
      <section className="relative h-[50vh] min-h-[400px] pt-16">
        <div className="absolute inset-0">
          <img 
            src={HERO_IMAGE} 
            alt="in-dekor showroom" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center text-center px-4">
          <div>
            <p className="font-heading text-xs uppercase tracking-[0.3em] text-white/80 mb-4">
              Our Story
            </p>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">
              About <span className="text-[#C4A882]">in-dekor™</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Brand Story */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="font-heading text-xs uppercase tracking-[0.2em] text-[#C4A882] mb-3">Our Heritage</p>
              <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#1A1A1A] tracking-tight mb-6">
                Crafting Excellence Since Day One
              </h2>
              <div className="space-y-4 font-body text-[#666666] leading-relaxed">
                <p>
                  in-dekor™ was born from a simple belief: that every space deserves furniture that tells a story. 
                  Founded by Usman Furniturewala in the heart of Mumbai, we've grown from a small workshop 
                  to a trusted name in premium furniture.
                </p>
                <p>
                  Our journey began on Nizam Street, where generations of craftsmen have honed their skills. 
                  Today, we combine this rich heritage with contemporary design sensibilities to create 
                  furniture that's both timeless and modern.
                </p>
                <p>
                  Every piece that leaves our workshop carries with it the dedication of our artisans, 
                  the quality of carefully sourced materials, and the vision of creating spaces that 
                  inspire and comfort.
                </p>
              </div>
            </div>
            <div>
              <img 
                src={WORKSHOP_IMAGE}
                alt="Craftsman at work"
                className="w-full h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-[#F9F9F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="font-heading text-xs uppercase tracking-[0.2em] text-[#C4A882] mb-3">What We Stand For</p>
            <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#1A1A1A] tracking-tight">
              Our Values
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: 'Quality Craftsmanship',
                description: 'Every joint, every finish, every detail is executed with precision. We use only the finest materials and time-tested techniques.'
              },
              {
                title: 'Custom Solutions',
                description: 'We understand that every space is unique. Our team works closely with you to create furniture that fits your vision perfectly.'
              },
              {
                title: 'Mumbai Pride',
                description: 'We\'re proud of our Mumbai roots. Every piece is made locally, supporting our community of skilled artisans.'
              }
            ].map((value, index) => (
              <div key={index} className="text-center p-8">
                <div className="w-16 h-16 mx-auto mb-6 bg-[#C4A882]/10 flex items-center justify-center">
                  <span className="font-heading text-2xl font-bold text-[#C4A882]">0{index + 1}</span>
                </div>
                <h3 className="font-heading text-xl font-semibold text-[#1A1A1A] mb-3">{value.title}</h3>
                <p className="font-body text-[#666666] leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Locations */}
      <section className="py-24" data-testid="locations-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="font-heading text-xs uppercase tracking-[0.2em] text-[#C4A882] mb-3">Visit Us</p>
            <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#1A1A1A] tracking-tight">
              Our Locations
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

            
            {/* Workshop */}
            <div className="bg-[#F9F9F8] p-8" data-testid="workshop-address">
              <p className="font-heading text-xs uppercase tracking-[0.2em] text-[#C4A882] mb-2">Workshop</p>
              <h3 className="font-heading text-xl font-semibold mb-4 text-[#1A1A1A]">Nizam Street</h3>
              <address className="font-body text-[#666666] not-italic leading-relaxed">
                95, Nizam Street,<br />
                Mumbai - 400003<br />
                Maharashtra, India
              </address>
            </div>
          </div>
        </div>
      </section>

      {/* Owner */}
      <section className="py-24 bg-[#1A1A1A]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="font-heading text-xs uppercase tracking-[0.2em] text-[#C4A882] mb-3">Founder</p>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white tracking-tight mb-6">
            Usman Furniturewala
          </h2>
          <p className="font-body text-gray-400 leading-relaxed max-w-2xl mx-auto">
            "Furniture isn't just about function—it's about creating spaces where memories are made. 
            At in-dekor™, we pour our heart into every piece, ensuring that when it reaches your home, 
            it carries a piece of our passion with it."
          </p>
          <p className="font-body text-[#C4A882] mt-6">
            usmanfurniturewala@gmail.com
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
